module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1), _vm._v(" "), (!_vm.loading) ? _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.showFacebookPixel) ? _c('img', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "height": "1",
      "width": "1",
      "src": "https://www.facebook.com/tr?id=1442556416455138&ev=PageView&noscript=1"
    }
  }) : _vm._e(), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md8": ""
    }
  }, [_c('sk-panel', [_c('h3', [_vm._v("Confirm Your Details")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "checkout",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('p', {
    staticClass: "form-alert"
  }, [_vm._v("All fields are mandatory")]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('sk-input', {
    staticClass: "light-input",
    attrs: {
      "name": "name",
      "autocomplete": "name",
      "label": "Your name",
      "required": "",
      "error-message": {
        valueMissing: 'Please tell us your name.'
      }
    },
    on: {
      "input": function($event) {
        _vm.user.isTemp = true
      }
    },
    model: {
      value: (_vm.user.FullName),
      callback: function($$v) {
        _vm.$set(_vm.user, "FullName", $$v)
      },
      expression: "user.FullName"
    }
  })], 1)], 1), _vm._v(" "), _c('sk-input', {
    staticClass: "light-input",
    attrs: {
      "name": "email",
      "type": "email",
      "autocomplete": "email",
      "label": "Your email",
      "required": "",
      "error-message": {
        valueMissing: 'Please make sure your email address follows this format: example@email.com'
      }
    },
    on: {
      "input": function($event) {
        _vm.user.isTemp = true
      }
    },
    model: {
      value: (_vm.user.Email),
      callback: function($$v) {
        _vm.$set(_vm.user, "Email", $$v)
      },
      expression: "user.Email"
    }
  }, [_c('template', {
    slot: "help"
  }, [_c('sk-tooltip', {
    attrs: {
      "content": _vm.isGuest ? 'We\'ll email your booking confirmation to you.' : 'We\'ll email your booking confirmation to you. Changing your email address here will not affect your profile.',
      "action-text": "Why do I need to provide my email address?"
    }
  })], 1)], 2), _vm._v(" "), _c('sk-input', {
    staticClass: "light-input",
    attrs: {
      "type": "tel",
      "name": "mobile",
      "autocomplete": "tel",
      "label": "Your mobile number",
      "required": "",
      "error-message": {
        valueMissing: 'Please enter your mobile number',
        patternMismatch: 'Please double check you\'ve entered 9 digits excluding your country code.'
      },
      "pattern": "^\\+?\\d{11,11}|\\d{10,10}$"
    },
    on: {
      "input": function($event) {
        _vm.user.isTemp = true
      }
    },
    model: {
      value: (_vm.user.MobilePhone),
      callback: function($$v) {
        _vm.$set(_vm.user, "MobilePhone", $$v)
      },
      expression: "user.MobilePhone"
    }
  }, [_c('template', {
    slot: "help"
  }, [_c('sk-tooltip', {
    attrs: {
      "content": _vm.isGuest ? 'We might need to reach you should there be changes that impact your booking.' : 'We might need to reach you should there be changes that impact your booking. Changing your number here will not affect your profile.',
      "action-text": "Why do I need to provide my mobile number?"
    }
  })], 1)], 2), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    staticClass: "subscribe-payment-debit-day",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "debit-order-label",
    attrs: {
      "for": "debitOrderDay"
    }
  }, [_vm._v("\n                                  Debit OrderDay "), _c('sk-tooltip', {
    key: "debit-order-tooltip",
    attrs: {
      "content": "This should probably be on payday. The subscription is for a minimum of three months and the second month will be deducted on this day.",
      "standalone": ""
    }
  })], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('sk-select', {
    attrs: {
      "placeholder": "Month",
      "type": "number",
      "required": "",
      "error-message": {
        valueMissing: 'Please select a debit order day.'
      }
    },
    model: {
      value: (_vm.debitOrderDay),
      callback: function($$v) {
        _vm.debitOrderDay = $$v
      },
      expression: "debitOrderDay"
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Debit Order Day")]), _vm._v(" "), _vm._l((_vm.debitDays), function(day) {
    return (day != undefined && day != null) ? _c('option', {
      domProps: {
        "value": day.day
      }
    }, [_vm._v(_vm._s(day.name))]) : _vm._e()
  })], 2)], 1)], 1), _vm._v(" "), (_vm.isGuest && _vm.user.isTemp) ? _c('sk-checkbox', {
    attrs: {
      "id": "userLinkCards",
      "label": "Save this information for next time"
    },
    model: {
      value: (_vm.saveUserData),
      callback: function($$v) {
        _vm.saveUserData = $$v
      },
      expression: "saveUserData"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('sk-tooltip', {
    attrs: {
      "content": "We use cookies to store your details and speed up your booking the next time you visit."
    }
  })], 1)], 2) : _vm._e(), _vm._v(" "), _c('sk-checkbox', {
    staticClass: "newsletter__subscribe",
    attrs: {
      "id": "userLinkCards",
      "label": "Use my email to subscribe me to the SK newsletter"
    },
    model: {
      value: (_vm.saveNewsLetter),
      callback: function($$v) {
        _vm.saveNewsLetter = $$v
      },
      expression: "saveNewsLetter"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("Be the first to enter our competitions and receive invitations to exclusive events.")])], 2), _vm._v(" "), _c('p', [_vm._v("By clicking pay, you agree to our "), _c('a', {
    attrs: {
      "href": "/content/legal/online-booking-terms-and-conditions",
      "target": "_blank"
    }
  }, [_vm._v("Terms & Conditions")]), _vm._v(". Valid for standard 2D and 3D shows only.")]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "payment-info": ""
    }
  }, [_c('sk-spacer'), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md9": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "text-right": ""
    }
  }, [_c('p', {
    staticClass: "text--small"
  }, [_vm._v("Ster-Kinekor is secure. For credit card payments we accept")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('sk-spacer'), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm6": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/visa.png",
      "alt": "Visa"
    }
  })]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm6": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/master-card.png",
      "alt": "Master Card"
    }
  })])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', {
    class: _vm.$breakpoints.smDown ? 'text-right' : '',
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "payment-footer": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": "",
      "sm10": "",
      "grow": "",
      "text-right": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "payment-footer-btns": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('form', {
    staticClass: "form",
    attrs: {
      "name": "Post",
      "action": _vm.adumoAPI,
      "method": "post"
    }
  }, [(_vm.paymentDetails) ? [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "Mode"
    },
    domProps: {
      "value": _vm.paymentDetails.Mode
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "MerchantID"
    },
    domProps: {
      "value": _vm.paymentDetails.MerchantID
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "ApplicationID"
    },
    domProps: {
      "value": _vm.paymentDetails.ApplicationID
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "MerchantReference"
    },
    domProps: {
      "value": _vm.paymentDetails.MerchantReference
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "Amount"
    },
    domProps: {
      "value": _vm.paymentDetails.Amount
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "Token"
    },
    domProps: {
      "value": _vm.paymentDetails.Token
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "txtCurrencyCode"
    },
    domProps: {
      "value": _vm.paymentDetails.txtCurrencyCode
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "RedirectSuccessfulURL"
    },
    domProps: {
      "value": _vm.paymentDetails.RedirectSuccessfulURL
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "RedirectFailedURL"
    },
    domProps: {
      "value": _vm.paymentDetails.RedirectFailedURL
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "ShippingCountryCode",
      "value": "ZA"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "Variable1"
    },
    domProps: {
      "value": _vm.paymentDetails.memberID
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "Variable2"
    },
    domProps: {
      "value": _vm.paymentDetails.email
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "Variable3"
    },
    domProps: {
      "value": _vm.debitOrderDay
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "Variable4"
    },
    domProps: {
      "value": _vm.paymentDetails.sessionToken
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "Variable5"
    },
    domProps: {
      "value": _vm.paymentDetails.firstname
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "Variable6"
    },
    domProps: {
      "value": _vm.paymentDetails.lastname
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "Variable7"
    },
    domProps: {
      "value": _vm.paymentDetails.subscriptionType
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "Variable8"
    },
    domProps: {
      "value": _vm.paymentDetails.subscriptionId
    }
  })] : _vm._e(), _vm._v(" "), (_vm.subsClub.item.Description == 'Limited Subs') ? [_c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit",
      "contextValue": "Subscription make payment",
      "dataValue": "Pay for Fan club"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.eft = false
      }
    }
  }, [_vm._v("MAKE PAYMENT")])] : _vm._e(), _vm._v(" "), (_vm.subsClub.item.Description == 'Unlimited Subs') ? [_c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit",
      "contextValue": "Subscription make payment",
      "dataValue": "Pay for Morvies club"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.eft = false
      }
    }
  }, [_vm._v("MAKE PAYMENT")])] : _vm._e()], 2)])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": "",
      "md2": ""
    }
  }, [(_vm.subsClub.item.Description == 'Limited Subs') ? [_c('sk-button', {
    attrs: {
      "link": "",
      "router": "",
      "to": "/subscribe/1",
      "contextValue": "Subscription Confirm Details",
      "dataValue": "Back to Fanclub subscription summary"
    }
  }, [_vm._v("Back")])] : _vm._e(), _vm._v(" "), (_vm.subsClub.item.Description == 'Unlimited Subs') ? [_c('sk-button', {
    attrs: {
      "link": "",
      "router": "",
      "to": "/subscribe/1",
      "contextValue": "Subscription Confirm Details",
      "dataValue": "Back to Morvies club subscription summary"
    }
  }, [_vm._v("Back")])] : _vm._e()], 2)], 1)], 1)])])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": ""
    }
  }, [_c('sk-panel', [(_vm.subsClub.item.Description == 'Limited Subs') ? [_c('div', {
    staticClass: "limited-subs"
  }, [_c('h3', [_vm._v("Subscription Summary")]), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('div', {
    staticClass: "img-container"
  }, [_c('img', {
    staticClass: "img-responsive img-option",
    attrs: {
      "src": "/static/img/fan_club_card.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    staticClass: "subscription-summary-heading",
    attrs: {
      "xs7": ""
    }
  }, [_c('p', [_c('span', [_vm._v("LIMITED MOVIE TICKETS PER MONTH")]), _c('br'), _vm._v("\n                                    You get 4 2D or 3D movie tickets per month for you and your family.\n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-limited-tickets-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("4 MOVIE TICKETS PER MONTH")]), _vm._v(" "), _c('br'), _vm._v("\n                                    You watch more for less\n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-combo-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("DISCOUNTS ON SNACKS")]), _vm._v(" "), _c('br'), _vm._v("\n                                    20% off a regular combo\n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-limited-users-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("IDEAL FOR THE FAMILY")]), _vm._v(" "), _c('br'), _vm._v("\n                                    Use one or all four tickets at once\n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-location-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("NOW AVAILABLE AT ALL CINEMAS")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ticket-component"
  }, [_c('div', {
    staticClass: "ticket-component-wrapper ticket-component-total"
  }, [_c('div', {
    staticClass: "ticket-total"
  }, [_c('div', {
    staticClass: "layout row"
  }, [_c('div', {
    staticClass: "flex xs12 sm12"
  }, [_c('p', [_vm._v("Total " + _vm._s(_vm.subsClub.item.Price) + " "), _c('span', [_vm._v("per month")])])])])])])])], 1)] : _vm._e(), _vm._v(" "), (_vm.subsClub.item.Description == 'Unlimited Subs') ? [_c('div', {
    staticClass: "unlimited-subs"
  }, [_c('h3', [_vm._v("Subscription Summary")]), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('div', {
    staticClass: "img-container"
  }, [_c('img', {
    staticClass: "img-responsive img-option",
    attrs: {
      "src": "/static/img/morvies_club_card.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    staticClass: "subscription-summary-heading",
    attrs: {
      "xs7": ""
    }
  }, [_c('p', [_c('span', [_vm._v("UNLIMITED MOVIES PER MONTH")]), _c('br'), _vm._v("\n                                    Watch as many 2D or 3D movies as you want all month long.\n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-unlimited-tickets-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("UNLIMITED MOVIE TICKETS PER MONTH")]), _vm._v(" "), _c('br'), _vm._v("\n                                    Watch up to 5 movies a day, every day!\n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-combo-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("DISCOUNTS ON SNACKS")]), _vm._v(" "), _c('br'), _vm._v("\n                                    20% off a regular combo\n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-unlimited-users-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("COME AS OFTEN AS YOU CAN")]), _vm._v(" "), _c('br'), _vm._v("\n                                    1 ticket per movie per card holder\n                                ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-location-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("NOW AVAILABLE AT ALL CINEMAS")])])])], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "ticket-component-wrapper ticket-component-total"
  }, [_c('div', {
    staticClass: "ticket-total"
  }, [_c('div', {
    staticClass: "layout row"
  }, [_c('div', {
    staticClass: "flex xs12 sm12"
  }, [_c('p', [_vm._v("Total " + _vm._s(_vm.subsClub.item.Price) + " "), _c('span', [_vm._v("per month")])])])])])])])], 1)] : _vm._e()], 2)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-342dda29","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subs-club/confirm-details/confirm-details.vue
// module id = 807
// module chunks = 0